import React from "react";
import { useNavigate } from "react-router-dom";

function RoleSelect() {
  const navigate = useNavigate();

  const roles = [
    {
      name: "Admin Login",
      onClick: () => navigate("/admin-login"),
      accent: "from-sky-500 to-cyan-400",
      ring: "border-sky-200/50",
      panel: "bg-[linear-gradient(160deg,_rgba(14,165,233,0.22),_rgba(15,23,42,0.1))]",
      button: "bg-sky-600 hover:bg-sky-500 text-white"
    },
    {
      name: "Engineer Login",
      onClick: () => navigate("/engineer-login"),
      accent: "from-emerald-500 to-lime-400",
      ring: "border-emerald-200/50",
      panel: "bg-[linear-gradient(160deg,_rgba(16,185,129,0.22),_rgba(6,78,59,0.1))]",
      button: "bg-emerald-600 hover:bg-emerald-500 text-white"
    },
    {
      name: "Accounts Login",
      onClick: () => navigate("/accounts-login"),
      accent: "from-amber-400 to-yellow-300",
      ring: "border-amber-200/60",
      panel: "bg-[linear-gradient(160deg,_rgba(245,158,11,0.22),_rgba(120,53,15,0.1))]",
      button: "bg-amber-500 hover:bg-amber-400 text-stone-950"
    },
    {
      name: "LG Attendance",
      onClick: () => navigate("/attendance"),
      accent: "from-orange-400 to-amber-300",
      ring: "border-orange-200/50",
      panel: "bg-[linear-gradient(160deg,_rgba(249,115,22,0.22),_rgba(15,23,42,0.1))]",
      button: "bg-orange-500 hover:bg-orange-400 text-white"
    }
  ];

  return (
    <div className="relative min-h-screen overflow-hidden bg-[linear-gradient(135deg,_#020617,_#111827_45%,_#0f172a)] px-4 py-10 text-white">
      <div className="absolute left-[-8rem] top-[-4rem] h-80 w-80 rounded-full bg-sky-500/20 blur-3xl" />
      <div className="absolute right-[-7rem] top-24 h-96 w-96 rounded-full bg-emerald-500/10 blur-3xl" />
      <div className="absolute bottom-[-8rem] left-1/3 h-96 w-96 rounded-full bg-amber-400/10 blur-3xl" />

      <div className="relative mx-auto flex min-h-screen max-w-6xl items-center justify-center">
        <div className="w-full overflow-hidden rounded-[2.25rem] border border-white/10 bg-white/8 shadow-[0_30px_120px_rgba(2,6,23,0.55)] backdrop-blur-xl">
          <div className="border-b border-white/10 px-6 py-10 text-center sm:px-10">
            <h1 className="text-5xl font-black tracking-tight text-white sm:text-6xl">
              Genmech Service
            </h1>
            <p className="mt-4 text-sm font-semibold uppercase tracking-[0.35em] text-slate-300 sm:text-base">
              Select Your Role
            </p>
          </div>

          <div className="grid gap-6 p-6 sm:p-8 lg:grid-cols-4 lg:p-10">
            {roles.map((role) => (
              <div
                key={role.name}
                className={`rounded-[1.75rem] border ${role.ring} ${role.panel} p-6 shadow-lg transition duration-300 hover:-translate-y-1 hover:shadow-2xl`}
              >
                <div className={`h-1.5 w-20 rounded-full bg-gradient-to-r ${role.accent}`} />
                <button
                  onClick={role.onClick}
                  className={`mt-6 w-full rounded-2xl px-4 py-4 text-lg font-semibold transition ${role.button}`}
                >
                  {role.name}
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default RoleSelect;
